<script lang="ts" setup>
import {
  AppLink,
} from '#components'

const { loadLayout, layoutData } = useLayout()
await loadLayout()

function getElement(to: string | null | undefined) {
  return to ? AppLink : 'span'
}
</script>

<template>
  <div
    v-if="layoutData?.legal?.[0]?.Items?.length"
    class="footer-legal"
  >
    <div
      v-if="layoutData.legal[0]?.Title"
      class="footer-legal__title"
    >
      {{ layoutData.legal[0].Title }}
    </div>

    <ul class="footer-legal__list">
      <li
        v-for="(group, index) in layoutData.legal[0].Items"
        :key="index"
        class="footer-legal__item"
      >
        <component
          :is="getElement(group.Link)"
          v-if="group.Name"
          :to="group.Link"
          class="footer-legal__link"
        >
          {{ group.Name }}
        </component>
      </li>
    </ul>
  </div>
</template>

<style>
@import url("~layers/components/Footer/Legal.css");
</style>
